import { useCallback, useRef } from "react";

/**
 * Mantém filters estáveis para search (via ref) e ignora respostas atrasadas
 * quando uma busca mais nova já foi disparada.
 *
 * O ref é sincronizado durante o render (não só no useEffect), para o clique
 * em "Buscar" logo após digitar não usar filtros antigos.
 */
export function useStableSearch(userToken, filters, runSearch) {
  const filtersRef = useRef(filters);
  const requestIdRef = useRef(0);

  filtersRef.current = filters;

  const search = useCallback(
    async (overrideFilters) => {
      if (!userToken) {
        return;
      }

      const requestId = ++requestIdRef.current;
      const activeFilters = overrideFilters ?? filtersRef.current;
      await runSearch({
        token: userToken,
        filters: activeFilters,
        isCurrent: () => requestId === requestIdRef.current,
      });
    },
    [userToken, runSearch]
  );

  return search;
}
